module.exports = __webpack_public_path__ + "static/media/scoring.a30aa72d.png";